import { render, staticRenderFns } from "./HomeTab.vue?vue&type=template&id=a6a45a26&scoped=true&"
import script from "./HomeTab.vue?vue&type=script&lang=js&"
export * from "./HomeTab.vue?vue&type=script&lang=js&"
import style0 from "./HomeTab.vue?vue&type=style&index=0&id=a6a45a26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a45a26",
  null
  
)

export default component.exports